module.exports = __webpack_public_path__ + "img/19.8586b759.jpg";